import { render, staticRenderFns } from "./TextCategory.vue?vue&type=template&id=96d9cf3e&scoped=true&"
import script from "./TextCategory.vue?vue&type=script&lang=js&"
export * from "./TextCategory.vue?vue&type=script&lang=js&"
import style0 from "./TextCategory.vue?vue&type=style&index=0&id=96d9cf3e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d9cf3e",
  null
  
)

export default component.exports